import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Radio, Label, Error } from 'app/components';
import { FieldRenderProps } from '../DataInputs';

const propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.arrayOf(PropTypes.object),
  dataFields: PropTypes.shape({
    hall: PropTypes.shape(FieldRenderProps)
  }).isRequired,
  submitFailed: PropTypes.bool.isRequired
};

const defaultProps = {
  errors: []
};

const HallCapacity = ({ form, errors, dataFields: { hall }, submitFailed }) => {
  const [t] = useTranslation();

  const restrictedCountries = ["hrv"];

  return (
    <div className="cinema-rent__hall-capacity-wrapper">
      <h2>{t('cinema_rent_inquiry_form.hall_capacity')} *</h2>
      <div className="cinema-rent__hall-capacity-container">
      {!restrictedCountries.includes(process.env.REACT_APP_COUNTRY) ? (
        <Label className="cinema-rent__hall-radio">
          {process.env.REACT_APP_COUNTRY !== "srb" ? (
            <>
              <Radio
                id={hall.input.name}
                checked={hall.input.value === 'up to 50'}
                title="index"
                value="up to 50"
                onChange={e => form.change(hall.input.name, e.target.value)}
              /> 
              <h3>{t('cinema_rent_inquiry_form.up_to', { num: 50 })}</h3>
            </>
          ) : (
            <>
              <Radio
                id={hall.input.name}
                checked={hall.input.value === 'up to 60'}
                title="index"
                value="up to 60"
                onChange={e => form.change(hall.input.name, e.target.value)}
              />
              <h3>{t('cinema_rent_inquiry_form.up_to', { num: 60 })}</h3>
            </>
          ) }
        </Label>
      ) : (
        <Label className="cinema-rent__hall-radio">
          <Radio
            id={hall.input.name}
            checked={hall.input.value === 'up to 100'}
            title="index"
            value="up to 100"
            onChange={e => form.change(hall.input.name, e.target.value)}
          />
          <h3>{t('cinema_rent_inquiry_form.up_to', { num: 100 })}</h3>
        </Label>
      )}
        <Label className="cinema-rent__hall-radio">
          <Radio
            id={hall.input.name}
            checked={hall.input.value === 'up to 150'}
            title="index"
            value="up to 150"
            onChange={e => form.change(hall.input.name, e.target.value)}
          />
          <h3>{t('cinema_rent_inquiry_form.up_to', { num: 150 })}</h3>
        </Label>
        <Label className="cinema-rent__hall-radio">
          <Radio
            id={hall.input.name}
            checked={hall.input.value === 'up to 200'}
            title="index"
            value="up to 200"
            onChange={e => form.change(hall.input.name, e.target.value)}
          />
          <h3>{t('cinema_rent_inquiry_form.up_to', { num: 200 })}</h3>
        </Label>
        <Label className="cinema-rent__hall-radio">
          <Radio
            id={hall.input.name}
            checked={hall.input.value === 'up to 300'}
            title="index"
            value="up to 300"
            onChange={e => form.change(hall.input.name, e.target.value)}
          />
          <h3>{t('cinema_rent_inquiry_form.up_to', { num: 300 })}</h3>
        </Label>
        {!restrictedCountries.includes(process.env.REACT_APP_COUNTRY) && (
          <>
            <Label className="cinema-rent__hall-radio">
              <Radio
                id={hall.input.name}
                checked={hall.input.value === 'up to 400'}
                title="index"
                value="up to 400"
                onChange={e => form.change(hall.input.name, e.target.value)}
              />
              <h3>{t('cinema_rent_inquiry_form.up_to', { num: 400 })}</h3>
            </Label>
            <Label className="cinema-rent__hall-radio">
              <Radio
                id={hall.input.name}
                checked={hall.input.value === 'more than 400'}
                title="index"
                value="more than 400"
                onChange={e => form.change(hall.input.name, e.target.value)}
              />
              <h3>{t('cinema_rent_inquiry_form.more_than', { num: 400 })}</h3>
            </Label>
          </>
        )}
      </div>
      {submitFailed && hall.meta.error && <Error>{t(...hall.meta.error)}</Error>}
    </div>
  );
};

HallCapacity.propTypes = propTypes;
HallCapacity.defaultProps = defaultProps;

export default memo(HallCapacity);
